// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dispatchNotificationEvent } from "../../NotificationSystem";
import { FileType } from "../../utils";
import { renderSystem } from "../renderSystem";
import produce from "immer";
export function smilesIsValid(smiles) {
    const rdkit = window.RDKit;
    const mol = rdkit.get_mol(smiles);
    return mol && mol.is_valid();
}
export function handleLoadSMILES(vss, molstar, pyodide, smiles, quiet) {
    return __awaiter(this, void 0, void 0, function* () {
        const rdkit = window.RDKit;
        //   const _smiles = "O=C(c1cc(c(O)cc1O)C(C)C)N3Cc2ccc(cc2C3)CN4CCN(CC4)C";
        const mol = rdkit.get_mol(smiles);
        if (!mol || !mol.is_valid()) {
            if (!quiet)
                dispatchNotificationEvent({
                    message: "Invalid SMILES string.",
                    type: "error",
                });
            if (mol)
                mol.delete();
            return;
        }
        const molBlock = mol.get_molblock();
        if (!molBlock) {
            if (!quiet)
                dispatchNotificationEvent({
                    message: "Invalid SMILES string.",
                    type: "error",
                });
            return;
        }
        const sdfData = molBlock + "\n\n$$$$";
        const fileName = `${smiles}.sdf`;
        const customFile = {
            name: smiles,
            // size: fileSize,
            type: "application/octet-stream",
            // lastModified: stats.mtime,
            data: sdfData,
            isLoaded: true,
            isInLFS: false,
        };
        const filesDict = { [fileName]: customFile };
        const system = {
            name: smiles,
            files: [fileName],
            type: FileType.sdf,
        };
        yield renderSystem(vss, molstar, pyodide, filesDict, system);
        if (!system["cellRef"])
            return;
        //   system.files = [];
        const prevSystems = vss.getState().loaded_structures;
        const newSystems = produce(prevSystems, (draft) => {
            draft.push(system);
            draft[draft.length - 1].files = [];
        });
        vss.getState().set_loaded_structures(newSystems);
        // const blob = new Blob([sdfData], { type: 'chemical/x-mdl-sdfile' });
        // const url = URL.createObjectURL(blob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = 'molecule.sdf';
        // link.click();
        mol.delete();
        return system;
    });
}
